// Types
import { CountryCurrencyType } from "types/Currency";

export const COUNTRY_CURRENCY: CountryCurrencyType[] = [
  { id: "1", country: "RU", currencyIso: "RUB" },
  { id: "2", country: "BD", currencyIso: "BDT" },
  { id: "3", country: "IN", currencyIso: "INR" },
  { id: "4", country: "UZ", currencyIso: "UZS" },
  { id: "5", country: "TR", currencyIso: "TRY" },
  { id: "6", country: "PK", currencyIso: "PKR" },
  { id: "7", country: "", currencyIso: "EUR" },
  { id: "8", country: "", currencyIso: "USD" },
  { id: "9", country: "AZ", currencyIso: "AZN" },
  { id: "11", country: "KZ", currencyIso: "KZT" },
  { id: "12", country: "MM", currencyIso: "MMK" },
  { id: "13", country: "LK", currencyIso: "LKR" },
  { id: "14", country: "FR", currencyIso: "EUR" },
  { id: "15", country: "KE", currencyIso: "KES" },
  { id: "16", country: "VN", currencyIso: "VND" },
];

export const COUNTRY_CURRENCY_EVOLUTION = {
  AD: "EUR",
  AE: "AED",
  AF: "AFN",
  AG: "XCD",
  AL: "ALL",
  AM: "AMD",
  AO: "AOA",
  AR: "ARS",
  AS: "USD",
  AT: "EUR",
  AU: "AUD",
  AZ: "AZN",
  BA: "BAM",
  BB: "BBD",
  BD: "BDT",
  BE: "EUR",
  BF: "XOF",
  BG: "BGN",
  BH: "BHD",
  BI: "BIF",
  BN: "BND",
  BO: "BOB",
  BR: "BRL",
  BS: "BSD",
  BT: "BTN",
  BW: "BWP",
  BY: "BYN",
  BZ: "BZD",
  CA: "CAD",
  CC: "AUD",
  CD: "CDF",
  CG: "XAF",
  CH: "CHF",
  CK: "NZD",
  CL: "CLP",
  CM: "XAF",
  CN: "CNY",
  CO: "COP",
  CR: "CRC",
  CU: "CUP",
  CX: "AUD",
  CY: "EUR",
  CZ: "CZK",
  DE: "EUR",
  DK: "DKK",
  DM: "XCD",
  DO: "DOP",
  DZ: "DZD",
  EC: "USD",
  EE: "EUR",
  EG: "EGP",
  ER: "ERN",
  ES: "EUR",
  FI: "EUR",
  FJ: "FJD",
  FR: "EUR",
  GB: "GBP",
  GD: "XCD",
  GE: "GEL",
  GF: "EUR",
  GG: "GBP",
  GH: "GHS",
  GI: "GIP",
  GR: "EUR",
  GT: "GTQ",
  GU: "USD",
  HK: "HKD",
  HR: "EUR",
  HT: "HTG",
  HU: "HUF",
  ID: "IDR",
  IE: "EUR",
  IL: "ILS",
  IM: "GBP",
  IQ: "IQD",
  IS: "ISK",
  IT: "EUR",
  JE: "GBP",
  JM: "JMD",
  JO: "JOD",
  JP: "JPY",
  KG: "KGS",
  KH: "KHR",
  KM: "KMF",
  KN: "XCD",
  KP: "KPW",
  KR: "KRW",
  KW: "KWD",
  KY: "KYD",
  KZ: "KZT",
  LA: "LAK",
  LB: "LBP",
  LI: "CHF",
  LS: "LSL",
  LT: "EUR",
  LU: "EUR",
  LV: "EUR",
  LY: "LYD",
  MA: "MAD",
  MC: "EUR",
  MD: "MDL",
  ME: "EUR",
  MK: "MKD",
  ML: "XOF",
  MM: "MMK",
  MN: "MNT",
  MP: "USD",
  MT: "EUR",
  MU: "MUR",
  MX: "MXN",
  MY: "MYR",
  MZ: "MZN",
  NA: "NAD",
  NG: "NGN",
  NI: "NIO",
  NL: "EUR",
  NO: "NOK",
  NP: "NPR",
  NR: "AUD",
  NU: "NZD",
  OM: "OMR",
  PA: "PAB",
  PE: "PEN",
  PF: "XPF",
  PG: "PGK",
  PH: "PHP",
  PL: "PLN",
  PS: "ILS",
  PT: "EUR",
  PY: "PYG",
  QA: "QAR",
  RO: "RON",
  RS: "RSD",
  RU: "RUB",
  RW: "RWF",
  SA: "SAR",
  SC: "SCR",
  SD: "SDG",
  SE: "SEK",
  SG: "SGD",
  SI: "EUR",
  SK: "EUR",
  SM: "EUR",
  SN: "XOF",
  SO: "SOS",
  SR: "SRD",
  SS: "SSP",
  SV: "USD",
  SY: "SYP",
  SZ: "SZL",
  TF: "EUR",
  TH: "THB",
  TJ: "TJS",
  TL: "USD",
  TM: "TMT",
  TN: "TND",
  TR: "TRY",
  TT: "TTD",
  TW: "TWD",
  TZ: "TZS",
  UA: "UAH",
  UG: "UGX",
  US: "USD",
  UY: "UYU",
  UZ: "UZS",
  VE: "VES",
  VN: "VND",
  VU: "VUV",
  YE: "YER",
  ZA: "ZAR",
  ZW: "ZWL",
};
